import pillVideo1 from '../../videos/employee/pillVideo1.mp4';
import pillVideo2 from '../../videos/employee/pillVideo2.mp4';
import taxis from '../../videos/employee/taxis.mp4';
import video2006 from '../../videos/employee/timeline-2006.mp4';
import video2012 from '../../videos/employee/timeline-2012.mp4';
import video2013 from '../../videos/employee/timeline-2013.mp4';
import video2015 from '../../videos/employee/timeline-2015.mp4';
import titlePillVideo1 from '../../videos/employee/titlePillVideo1.mp4';
import titlePillVideo2 from '../../videos/employee/titlePillVideo2.mp4';
import titlePillVideo3 from '../../videos/employee/titlePillVideo3.mp4';
import titlePillVideo4 from '../../videos/employee/titlePillVideo4.mp4';
import valeursAudaceVideo from '../../videos/employee/valeurs-audace.mp4';
import valeursCuriositeVideo from '../../videos/employee/valeurs-curiosite.mp4';
import valeursHumourVideo from '../../videos/employee/valeurs-humour.mp4';
import valeursIrreverenceVideo from '../../videos/employee/valeurs-irreverence.mp4';
import valeursOuvertureVideo from '../../videos/employee/valeurs-ouverture-d-esprit.mp4';

import image2018 from '../../img/employee/URBANIA-Musique.png';
import arrowsClement from '../../img/employee/arrows-clement.png';
import arrowsMushrooms from '../../img/employee/arrows-mushrooms.png';
import arrowsOldLady from '../../img/employee/arrows-old-lady.png';
import arrowsOldMan from '../../img/employee/arrows-old-man.png';
import audace from '../../img/employee/audace.png';
import bgdehors from '../../img/employee/brands/dehors.jpg';
import bgfrance from '../../img/employee/brands/france.jpg';
import bgmollo from '../../img/employee/brands/mollo.jpg';
import bgperiode from '../../img/employee/brands/periode.jpg';
import bgquatre95 from '../../img/employee/brands/quatre95.jpg';
import bgurbania from '../../img/employee/brands/urbania.jpg';
import businessIngots from '../../img/employee/business-ingots.png';
import businessSpiral from '../../img/employee/business-spiral.png';
import espritDequipe from '../../img/employee/esprit-d-equipe.png';
import image2019B from '../../img/employee/folklorexurbania.png';
import youBLive from '../../img/employee/logo-you-b-live.png';
import modalImage2 from '../../img/employee/modal-2003-01.png';
import modalImage1 from '../../img/employee/modal-img1.jpg';
import modalImage3 from '../../img/employee/modal-img3.jpg';
import modalImage4 from '../../img/employee/modal-img4.jpg';
import ouverture from '../../img/employee/ouverture.png';
import rigueur from '../../img/employee/rigueur.png';
import image2003 from '../../img/employee/timeline-2003.jpg';
import image2008 from '../../img/employee/timeline-2008.jpg';
import image2014 from '../../img/employee/timeline-2014.png';
import image2015 from '../../img/employee/timeline-2015.png';
import image2019 from '../../img/employee/timeline-2019.png';
import image2021 from '../../img/employee/timeline-2021.png';
import valeursAudace from '../../img/employee/valeurs_audace.png';
import valeursCuriosite from '../../img/employee/valeurs_curiosite.png';
import valeursHumour from '../../img/employee/valeurs_humour.png';
import valeursIrreverence from '../../img/employee/valeurs_irreverence.png';
import valeursOuverture from '../../img/employee/valeurs_ouverture.png';

// colors
const red = '#FF0053';
const orange = '#F45C1F';
const yellow = '#FFE000';
const green = '#00E164';
const blue = '#9EfffD';
const pink = '#FF81C5';
const purple = '#b650ff';

export default {
    id: '999',
    type: 'employee',
    pageType: 'employee',
    handle: 'employee',
    published: true,
    title: 'Employés',
    description: 'Guide des employés',
    image: null,
    video: null,
    slug: 'employee',
    url: '/fr/employee',
    site: null,
    metadata: {
        url: 'https://employe.urbania.media/fr',
        urls: {
            fr: 'https://employe.urbania.media/fr',
            en: 'https://employee.media/en',
        },
        canonical: 'https://employe.urbania.media/fr',
        title: 'Employés',
        description:
            "URBANIA, c'est d'abord et avant tout un \u00e9tat d'esprit, un ADN unique qui d\u00e9ploie ses valeurs \u00e0 travers plusieurs marques m\u00e9dias, plusieurs auditoires, mais gardant toujours la m\u00eame mission : celle de rendre l'ordinaire extraordinaire. \u00c7a, \u00e7a veut dire que lorsqu'on raconte des histoires, qu'elles soient \u00e0 propos de finances personnelles, de culture universitaire, de plein-air ou de la soci\u00e9t\u00e9 dans laquelle on \u00e9volue, on le fait avec un soucis d'empathie et avec l'objectif de rapprocher les gens avec bienveillance, peu importe leurs diff\u00e9rences.",
        image: null,
        video: null,
    },
    parent: null,
    theme: {
        colors: { primary: '#222', secondary: '#222' },
        elementsColor: '#fff',
        highlights: '#fff',
    },
    blocks: [
        {
            id: 'employee-main-title',
            type: 'EmployeeMainTitle',
            body: 'Le <div><span>petit</span></div> Guide de<br/>l’Urbanien&#8288;:urbania:&#8288;ne',
            colors: { type: 'gradient', colors: [pink, red] },
        },
        {
            id: 'employee-text-01',
            type: 'employeeText',
            body: `<p>S’il y a une chose qu’on a apprise avec le temps, c’est que de définir ce qu’est le groupe URBANIA, son ADN, son ton, sa mission et ses valeurs, ce n’est pas une tâche facile, d’autant plus qu’on évolue en continu. Mais parce que vous, les membres de notre équipe, en êtes les ambassadeur.drice.s et êtes indispensables à la croissance et à l’attrait de la marque, ce serait donc <span style="color: ${red}">pas pire*</span> si on vous clarifiait tout ça, que vous compreniez (presque) parfaitement dans quel contexte s’inscrit votre travail et dans quelle culture d’entreprise vous évoluez ou venez tout juste de plonger. Que vous soyez cohérent.e.s et compréhensibles, pendant votre prochain party de Noël ou d’Hanouka, quand vous expliquerez à votre oncle de St-Eustache - ou de Clermont-Ferrand ou de Rabat - c’est quoi votre nouveau job.</p>`,
        },
        {
            id: 'employee-text-02',
            type: 'employeeText',
            body: '<p>Bienvenue dans le petit manuel de l’URBANIEN.NE : un guide, une référence, un glossaire. Vous y découvrirez des processus à appliquer, des inside jokes à mieux comprendre, des conseils pour mieux anticiper les meetings étranges dans votre agenda, mais surtout, c’est quoi URBANIA. C’est un petit manuel qui progresse avec le temps, avec vous.</p>',
        },
        {
            id: 'employee-text-03',
            type: 'employeeText',
            body: `<p style="color: ${red}; font-size: 14px">* Traumavertissement : les Anglais ayant gagné la bataille des Plaines d’Abraham contre les Français en 1759, on se fait le devoir de sauvegarder avec ardeur les spécificités de la culture québécoise francophone, celle qui a fait naître URBANIA. Ça passe par l’utilisation d’expressions familières qui feront certainement lever le sourcil de nos collègues européens, et de locutions dignes de leurs arrière-arrière-arrière-arrière-arrière-arrière-arrière-arrière-grands-parents (ou de leurs cousins qui ont déménagé à New York pour vivre l’American dream en franglais). Soyez averti.e.s.</p>`,
        },
        {
            id: 'employee-pills',
            type: 'EmployeePills',
            colors: { type: 'gradient', colors: ['#99FFFF', '#00CC66'] },
            pills: [
                { type: 'text', text: 'Faque', color: red },
                { type: 'text', text: 'finalement', color: purple },
                { type: 'video', width: 240, src: pillVideo1, color: blue },
                { type: 'text', text: "c'est", color: green },
                { type: 'text', text: 'quoi', color: orange },
                {
                    type: 'block',
                    pills: [
                        { type: 'text', text: 'URBANIA', color: yellow },
                        { type: 'text', text: '?', color: pink },
                    ],
                },
                { type: 'video', width: 100, src: pillVideo2, color: blue },
            ],
            text: '* Voilà, on avait prévenu !',
        },
        {
            id: 'employee-title-01',
            type: 'EmployeeTitle',
            body: '<h2>Ce en quoi nous croyons</h2>',
            colors: { type: 'gradient', colors: ['#99FFFF', '#00CC66'] },
            withLine: false,
        },
        {
            id: 'employee-text-04',
            type: 'employeeText',
            body: '<p>Faire partie de l’équipe URBANIA, c’est participer à faire grandir un groupe média indépendant et innovant, qui a comme mission de rendre l’ordinaire extraordinaire. Un média qui veut gagner de l’argent pour, avant tout, raconter plus d’histoires, toujours de meilleure qualité. Surtout pas le contraire :</p>',
        },
        {
            id: 'employee-image-05',
            type: 'EmployeeImageText',
            body: '<p>on ne se mettra certainement pas à diffuser de la saucisse&nbsp;:sausage:&nbsp;sans saveur pour attirer les clics&nbsp;:pointer:&nbsp;, question d’empocher des revenus&nbsp;:money:&nbsp;de bannières publicitaires louches&nbsp;:crosseyed:&nbsp;,</p>',
            color: green,
            withLine: true,
        },
        {
            id: 'employee-text-06',
            type: 'employeeText',
            body: '<p>ou encore produire des quiz télévisuels animés par Sébastien Benoît/Thierry Beccaro qui ciblent les 55-64 ans parce que ça nous assure un fonds de commerce tout en aliénant complètement nos équipes.</p>',
        },
        {
            id: 'employee-text-07',
            type: 'employeeText',
            body: '<p>Ce qui nous passionne, c’est de fabriquer du contenu, sous toutes ses formes. C’est de se mettre en danger, d’aller là où on ne nous attend pas, et de constamment explorer de nouveaux territoires pour rester pertinents et engageants dans la vie des gens.</p>',
        },
        {
            id: 'employee-text-08',
            type: 'employeeText',
            body: '<p>Et ça passe par notre culture d’entreprise. Une culture qui valorise d’abord et avant tout la créativité. Celle de tout le monde. Même celle des comptables. Parce qu’il n’y a pas de mauvaises idées, juste de mauvaises personnes™ (🤔). Et selon nous, la créativité est exacerbée et toujours améliorée quand une histoire se construit avec l’input de plusieurs, quand on travaille en équipe, quand on se challenge, quand on prend le crédit en gang, quand on affronte les moments difficiles en front commun. Quand on travaille à combiner son talent à celui de ses collègues, la magie s’opère et on fait de grandes choses… dans un esprit de clan incomparable.</p>',
        },
        {
            id: 'employee-text-09',
            type: 'employeeText',
            body: '<p>C’est dans le même ordre d’idée que nous avons développé notre relation non traditionnelle avec les notions de hiérarchie et d’autorité. Même si certains membres de l’équipe ont des responsabilités plus imposantes, ou sont les personnes imputables pour les activités d’un département ou d’un projet spécifique,</p>',
        },
        {
            id: 'employee-image-text-',
            type: 'EmployeeImageText',
            body: '<p>chez URBANIA, on traite tout le monde avec le même respect&nbsp;:respect:&nbsp;et la même déférence. Nous sommes tous des adultes : on peut se challenger et faire des critiques&nbsp;:hands:&nbsp;constructives, même à son boss&nbsp;:briefcase:&nbsp;, tant que ça se fait dans la bonne foi, l’humilité et l’ouverture&nbsp;:brain:&nbsp;d’esprit.</p>',
            color: pink,
            withLine: true,
        },
        {
            id: 'employee-text-10',
            type: 'employeeText',
            body: '<p>Même si cet esprit communal crée parfois un peu de confusion, si ça peut être étourdissant, 5 personnes qui donnent leur opinion sur la même vidéo, nous sommes d’avis que c’est un petit prix à payer pour développer un environnement stimulant, effervescent de créativité. Tant qu’on reste en mode solution, qu’on pose les bonnes questions, et qu’on travaille pour garder le cap, tous dans la même direction, ÇA VA BEN ALLER. 🌈</p>',
        },
        {
            id: 'employee-title-pills',
            type: 'EmployeeTitlePills',
            titlePills: [
                {
                    video: titlePillVideo1,
                    title: 'Notre mission',
                    text: "Rendre l'ordinaire extraordinaire.",
                    color: blue,
                },
                {
                    video: titlePillVideo2,
                    title: "Notre raison d'être",
                    text: 'Divertir les jeunes adultes avec intelligence, humour, audace et authenticité.',
                    color: purple,
                },
                {
                    video: titlePillVideo3,
                    title: 'Notre rêve le plus fou',
                    text: 'Devenir le meilleur média francophone international destiné aux jeunes adultes, qui célèbre l’humain.',
                    color: green,
                },
                {
                    video: titlePillVideo4,
                    title: 'Nos valeurs d’entreprise et notre&nbsp;équipe',
                    text: 'Pour que la chimie prenne dans une équipe et qu’on crée ensemble l’extraordinaire, il faut soigneusement choisir les membres qui la composent. C’est ainsi qu’on recherche principalement des personnes qui partagent nos valeurs d’entreprises.',
                    color: orange,
                },
            ],
        },
        {
            id: 'employee-card-stack',
            type: 'EmployeeCardStack',
            title1: 'Nos valeurs',
            title2: 'Nos collègues',
            cards: [
                {
                    title: 'L’esprit d’équipe',
                    text1: 'Le «&nbsp;nous&nbsp;» l’emporte sur le «&nbsp;moi&nbsp;». Faire converger ses ambitions personnelles avec celles de l’équipe et du groupe.',
                    text2: '…pensent au bien commun et savent allier leur mieux-être à celui du groupe. Ont le courage d’exprimer ce qui accroche, de manière constructive. En mode solution.',
                    color: blue,
                    image: espritDequipe,
                },
                {
                    title: 'L’audace',
                    text1: 'Une idée qui nous donne la chienne ? GO ! On fonce. On ne vous blâmera jamais d’avoir essayé.',
                    text2: '…ont de l’initiative. On aime les gens qui lèvent leur main, qui questionnent ce qui a été établi, qui ont un esprit d’intrapreneurship, qui rêvent d’inventer un nouveau métier.',
                    color: green,
                    image: audace,
                },
                {
                    title: 'L’ouverture d’esprit',
                    text1: 'S’intéresser à l’autre, sans jugement; être curieux.se de ses opinions divergentes, de son look surprenant, de sa personnalité unique, de ce qui l’émeut. Dans nos relations de travail et dans nos contenus.',
                    text2: '…ont la curiosité de l’autre bien allumée, sont cultivé.e.s, ont des dizaines de passions, peu importe lesquelles. Veulent constamment apprendre, savent qu’ils.elles ne savent pas tout.',
                    color: yellow,
                    image: ouverture,
                },
                {
                    title: 'La rigueur',
                    text1: 'Une attention aux détails, comme à la vue d’ensemble; au fond, comme à la forme.',
                    text2: '…sont rigoureux.euses et ressentent de la satisfaction quand le travail est bien fait.',
                    color: pink,
                    image: rigueur,
                },
            ],
        },
        {
            id: 'employee-text-11',
            type: 'employeeText',
            body: '<p>On ne s’attend pas nécessairement à ce que tous les employé.e.s d’URBANIA correspondent 100% à ce type de profil, mais on s’attend à ce que vous cochiez la majorité des cases. N’en demeure pas moins que l’équilibre qu’on entretient depuis des années pour favoriser l’esprit d’équipe et la collaboration efficace est trop important, et on ne fait pas de compromis là-dessus.</p>',
        },
        {
            id: 'employee-text-12',
            type: 'employeeText',
            body: '<p>Bien sûr, en plus de ces quatre valeurs principales, on s’attarde également à avoir un réel impact positif dans la société grâce à nos histoires, être un bon citoyen corporatif, offrir un environnement de travail sain, accueillant  et stimulant pour tous, et réduire notre empreinte carbone. On oublie quelque chose ? On peut faire mieux ? Faites-nous-en part.</p>',
        },
        {
            id: 'employee-text-13',
            type: 'employeeText',
            body: '<p>Mais tout ça n’est pas né du jour au lendemain…</p>',
        },
        {
            id: 'employee-title-histoire',
            type: 'EmployeeTitle',
            body: 'La petite histoire',
            colors: { type: 'gradient', colors: ['#A900FD', red] },
        },
        {
            id: 'employee-timeline',
            type: 'EmployeeTimeline',
            entries: [
                {
                    year: '2000',
                    color: green,
                    linkColor: 'purple',
                    details: [
                        {
                            title: 'Toxa.com',
                            text: 'Dans l’ancien temps, au tournant du millénaire, un designer graphique (Philippe Lamarre) qui se faisait tout le temps mettre dehors de ses jobs en agence et son BFF d’enfance qui avait étudié en administration à Juan-les-Pins (Vianney Tremblay) ont mis sur pied une petite agence de communication qu’ils ont appelée TOXA. Parce que c’était un nom court, que ça se disait dans les deux langues, et que le .com était disponible. Ils créaient des cartes d’affaires, mettaient en page des rapports annuels, montaient des sites web corpo, fumaient des battes, et chialaient contre leurs clients trop <em>straight</em>.',
                            modals: [
                                {
                                    title: 'Du troc',
                                    text: 'Ça, c’est le genre de cartes d’affaires que produisait TOXA en échange de… marchandises. Du moins pour les amis dealers de MDMA (c’était le début des années 2000, ok?!). ¯\\_(ツ)_/¯',
                                    image: modalImage1,
                                    layout: 'imageTop',
                                },
                            ],
                        },
                    ],
                },
                {
                    year: '2003',
                    color: blue,
                    details: [
                        {
                            title: 'La genèse d’urbania',
                            text: 'La bande d’ami.e.s rassemblé.e.s dans un loft du boulevard Saint-Laurent décide de lancer un magazine dont le premier numéro a pour thème la «&nbsp;locomotion&nbsp;», avec en couverture un vieux barbu au look de Hell’s Angels écolo chevauchant un vélo. C’est d’ailleurs ce dernier qui a inspiré la thématique, fascinant nos comparses à chacun de leurs passages au Tim Horton’s où il traînait (à l’époque où on n’avait pas de machine à café au bureau). Dans une véritable démarche 2.0 avant le temps, un sondage web demande aux utilisateur.trice.s de choisir la couleur officielle de la flotte de taxis montréalais, et c’est le rose qui l’emporte. La première édition d’URBANIA sera donc imprimée en noir… et rose.',
                            image: image2003,
                            modals: [
                                {
                                    title: 'Fun fact',
                                    text: 'En vrai, c’est le orange Julep qui avait reçu le plus de votes, mais on trouvait ça plus drôle d’élire le rose nanane. URBANIA est né sur un mensonge. #fakenews',
                                    image: modalImage2,
                                    video: taxis,
                                    layout: 'imageRight',
                                },
                                {
                                    title: 'Les influences',
                                    text: 'Ce sont les magazines Colors (financé par la compagnie de vêtements Benetton) et Macadam Tribu (émission de radio culte radiocanadienne du début des années 2000), de même que la série documentaire belge Strip Tease et le show radio This American Life, qui ont, au fil des années, inspiré la conception d’URBANIA, tant en format magazine que vidéo.',
                                    image: modalImage3,
                                    layout: 'imageLeft',
                                },
                            ],
                        },
                    ],
                },
                {
                    year: '2006',
                    color: purple,
                    linkColor: 'yellow',
                    details: [
                        {
                            title: 'On fait de la TV',
                            text: `À l’invitation de Catherine Pogonat, URBANIA passe à la télé et produit les <a href="https://www.youtube.com/playlist?list=PL7GSvd9nSfi2FDB1J1oAmB2xwIawNv0n1" target="_blank">Minutes Urbania</a> diffusées dans le cadre du magazine culturel <em>Mange ta ville</em> à ARTV. Réinventant en vidéo plusieurs rubriques issues du magazine telles que <em>En chiffres</em> et les <em>Vox Pop</em>, c’est l’épiphanie : la marque URBANIA peut exister au-delà du magazine. Nos horizons s’ouvrent alors.`,
                            video: video2006,
                            visualLink:
                                'https://www.youtube.com/watch?v=5f01LXjeiEg&list=PL7GSvd9nSfi2FDB1J1oAmB2xwIawNv0n1&index=14',
                        },
                    ],
                },
                {
                    year: '2007',
                    color: orange,
                    linkColor: 'blue',
                    details: [
                        {
                            title: 'Urbania à TV5',
                            text: 'Exploration multiplateforme de l’envers de la carte postale de lieux iconiques montréalais, la série documentaire <em>Montréal en 12 lieux</em> et le site MTL12.com sont produits pour la chaîne TV5. Le projet gagne les prix Gémeaux de la meilleure série documentaire de l’année et Site web de l’année, ainsi qu’une trâlée de prix internationaux. S’ensuit alors <em>Le Québec en 12 lieux</em>, qui sera diffusé à travers la francophonie sur le réseau TV5 Monde, permettant ainsi de faire découvrir le bar de danseurs nus 281 aux jeunes vietnamiennes.',
                        },
                    ],
                },
                {
                    year: '2008',
                    color: red,
                    details: [
                        {
                            title: 'C’est sérieux',
                            text: 'URBANIA quitte ses mythiques bureaux (appartements?) du boulevard St-Laurent, au coin de l’avenue des Pins, pour entrer dans le monde des adultes, au Centre-Ville. Installé.e.s sur St-Alexandre au Sternthal Building, on adopte le quartier des fourrures, un peu plus crédible pour nos clients de plus en plus importants',
                            image: image2008,
                        },
                    ],
                },
                {
                    year: '2009',
                    color: pink,
                    details: [
                        {
                            title: 'Urbania passe au HTML',
                            text: 'Après de nombreuses folies interactives programmées en Flash, on lance un portail de contenu alimenté quotidiennement et on développe notre communauté grâce aux réseaux sociaux. Le portail a connu une croissance exponentielle au fil des ans, il est aujourd’hui au cœur de la marque URBANIA.',
                        },
                    ],
                },
                {
                    year: '2012',
                    color: yellow,
                    linkColor: 'purple',
                    details: [
                        {
                            title: 'Paris, radio et jeu vidéo',
                            text: 'C’est le printemps Érable, une effervescence s’empare des rues de Montréal et on se joint au concert de casseroles en mettant sur pied une collaboration avec le groupe d’étudiants l’École de la Montagne rouge et l’ONF, de laquelle naissent un journal imprimé et une expérience interactive, <a href="https://www.onf.ca/interactif/rouge_au_carre_fr/" target="_blank">Rouge au carré</a>. On débarque dans la Ville Lumière pour produire un magazine qui s’intéresse aux Parisien.ne.s. Dans le temps des Fêtes qui suit, la première chaîne de Radio-Canada diffuse URBANIA RADIO sur ses ondes. Parallèlement, on produit un magazine hors-série en collaboration avec Ubisoft, une incursion réussie dans le marketing de contenu.',
                            video: video2012,
                            visualLink: 'https://www.onf.ca/interactif/rouge_au_carre_fr/',
                        },
                    ],
                },
                {
                    year: '2013',
                    color: green,
                    linkColor: 'purple',
                    details: [
                        {
                            title: 'Urbania a 10 ans',
                            text: 'Non seulement ce projet lancé par une bande d’amis existe encore 10 ans plus tard, mais le site web d’URBANIA cartonne et atteint la barre des 300 000 visiteurs uniques par mois. On produit désormais des séries télé, des webdocumentaires, des fictions interactives. On défriche sans arrêt et notre équipe grossit en conséquence.',
                            video: video2013,
                        },
                        {
                            title: 'Une école de création',
                            text: 'L’École Urbania est formée en partenariat avec l’Université du Québec à Montréal. Le concept est simple : une équipe composée d’étudiants provenant de diverses disciplines doit réaliser un projet de création appliquée. Qu’il s’agisse d’un magazine thématique, d’un manifeste urbain ou d’une websérie, les étudiants sont plongés dans une expérience réelle de création collective. Désormais rebaptisé le Lab URBANIA, le programme de stage attire annuellement des talents qui se démarquent (dont certains feront plus tard partie de l’équipe de manière permanente). On nous glisse d’ailleurs régulièrement à l’oreille que les autres universités québécoises sont un peu jalouses. ¯\\_(ツ)_/¯',
                        },
                    ],
                },
                {
                    year: '2014',
                    color: blue,
                    details: [
                        {
                            title: 'Deux fois l’an',
                            text: 'L’édition ANONYMAT est lancée et marque un changement pour URBANIA. Le magazine est maintenant deux fois plus costaud et publié deux fois l’an (auparavant trimestriel). Ça nous donne plein de temps libre supplémentaire pour développer nos productions télé et numériques; de nombreux projets sont mis en chantier et verront le jour en 2015 et 2016.',
                            image: image2014,
                        },
                    ],
                },
                {
                    year: '2015',
                    color: purple,
                    linkColor: 'blue',
                    details: [
                        {
                            title: 'Directement dans la fourche',
                            text: 'Né de l’union improbable mais légitime d’URBANIA et de RDS, le site web Balle courbe s’attaque au sport de façon décalée et audacieuse, avec pour mission de développer un angle de la couverture sportive qui n’est pas exploité au Québec. Après plusieurs années à piloter le contenu du site, le partenariat avec URBANIA a évolué vers des projets vidéo, dont celui de relancer le mini-putt sur les ondes de RDS! ',
                            video: video2015,
                            visualLink: 'https://www.youtube.com/watch?v=nh5BbLAAvec',
                        },
                        {
                            title: 'Toxa est mort, vive Urbania',
                            text: 'On était donc ben tanné de constamment hésiter entre nos deux cartes d’affaires à chaque rencontre professionnelle (ou potentielle <em>date</em>). Notre double personnalité - les gens sérieux chez TOXA et les ados pas tout le temps propres chez URBANIA - a commencé à peser, et on s’est rendu compte que notre marque média avait accumulé assez de crédibilité et de reconnaissance pour devenir le cœur de l’identité de l’entreprise. On a donc fait changer tous nos papiers, et l’ensemble de nos activités s’est retrouvé sous la bannière URBANIA : une agence de contenu, de la production de contenu original, et un réseau de sites web. On en profite aussi pour déménager sur la Place Roy, dans l’ancienne phonothèque de Montréal. (Ah pis c’est aussi le moment où la petite stagiaire rousse qui est rentrée en 2008 - Raphaëlle Huysmans - est devenue l’associée de Philippe, Vianney ayant quitté pour de nouvelles aventures quelques années plus tôt).',
                            image: image2015,
                            verticalImage: true,
                        },
                    ],
                },
                {
                    year: '2018',
                    color: orange,
                    linkColor: 'blue',
                    details: [
                        {
                            title: 'Comme un band garage',
                            text: 'À l’occasion de notre 15e anniversaire, URBANIA a fait un deuxième enfant, longuement désiré. A été lancé le 30 mai 2018 URBANIA Musique, un média musical qui s’intéresse aux humains derrière la chanson, ceux qui la produisent, qui la distribuent ou encore la reçoivent en plein coeur. La progéniture n’a malheureusement pas survécu à la pandémie de 2020, la promesse éditoriale n’attirant pas suffisamment les clients (ni l’audience, d’ailleurs) 😥.',
                            image: image2018,
                        },
                    ],
                },
                {
                    year: '2019',
                    color: red,
                    details: [
                        {
                            title: 'Quatre95',
                            text: '4,95$, c’était le prix de notre premier magazine (voir plus haut 👆); l’inspiration pour baptiser notre nouveau média qui traite de finances personnelles, d’entreprenariat, de travail et de consommation responsable chez les jeunes adultes. C’est aussi notre premier partenariat de grande envergure avec une marque premium, la Banque Nationale. 🤑',
                            image: image2019,
                        },
                        {
                            title: 'Gratuit',
                            text: 'Tant qu’à parler d’argent et d’affaires, on en a aussi profité pour revoir complètement le modèle de revenus et la formule de notre magazine imprimé. On passe d’un objet vendu 16,95$ en librairie, acheté par une poignée de personnes privilégiées, à un projet d’équipe, distribué gratuitement à notre communauté. Un 36 pages en papier journal fancy qui propose nos meilleures histoires, met en valeur nos verticales médias, tout ça en échange des données de base de nos lecteur.trice.s. Watch out Mark Zuckerberg! (Bon, une petite trêve pandémique le temps que les choses se stabilisent, quand même).',
                        },
                        {
                            title: 'Un mariage!',
                            text: 'Une grosse année, 2019 : c’est aussi le moment où URBANIA s’est officiellement associé à l’entreprise Folklore, une boîte de création interactive. Collaborant depuis déjà plusieurs années sur des projets parfois sérieux, parfois borderline inappropriés, il s’agit d’un partenariat pour réellement implanter une culture de créativité technologique au sein de l’équipe.',
                            image: image2019B,
                            verticalImage: true,
                            modals: [
                                {
                                    title: 'Notre pire/meilleur projet',
                                    text: 'Chatte Roux Laitte, c’est le microsite conçu par David et Marc-Antoine de Folklore qui a accompagné l’édition Sexe du magazine URBANIA en 2011. La plateforme, émulant le désormais célèbre Chatroulette, permettait aux internautes de filmer anonymement leurs parties génitales et d’être «&nbsp;matchés&nbsp;» aléatoirement avec un.e autre participant.e, dévoilant enfin au grand jour la réelle motivation des utilisateur.trice.s de la plateforme d’origine. Disons que ça ne passerait plus aujourd’hui...',
                                    image: modalImage4,
                                    layout: 'imageLeft',
                                },
                            ],
                        },
                    ],
                },
                {
                    year: '2020',
                    color: pink,
                    details: [
                        {
                            title: 'LE VIRUS URBANIA (arke) À LA CONQUÊTE DE LA FRANCE ET DES UNIVERSITAIRES',
                            text: 'Faque on a profité du début de l’année 2020 pour investir dans le lancement de nos activités sur le Vieux Continent, pour mettre au monde un nouveau média destiné aux universitaires (la relève!), pour signer un bail pour des locaux deux fois plus grands dans le mythique Rodier et - et ça c’est la bonne nouvelle -, pour migrer notre précieuse serveuse (voir explication plus loin) dans le cloud. Le 12 mars, on avait organisé un 5 à 7 avec 250 tacos pour nos client.e.s et partenaires privilégié.e.s. Quand la requête gouvernementale d’annuler les rassemblements de plus de 250 personnes est apparue en notification sur nos téléphones, on s’est dit que ce serait cool, ça ferait plus de chips au maïs pour l’équipe. Oupelaï.',
                        },
                        {
                            text: 'La pandémie a été l’occasion pour toute l’équipe de totalement s’unir, malgré l’incertitude, la distance, les difficultés économiques, la peur et la réalisation que des enfants ça demandent vraiment beaucoup d’attention. On a dû mettre un frein à la production du magazine imprimé, et même mettre la clef dans la porte de notre plateforme URBANIA Musique, qui ne générait pas les revenus nécessaires pour sa survie.',
                        },
                        {
                            text: 'MAIS! Ça a également été : un virage vidéo, apprendre à faire du live sur un dix cennes, découvrir les joies de Meet et de Slack. Jamais on a été aussi fiers de l’attitude résiliente de l’équipe, de ses idées innovantes, de son énergie, de sa solidarité.',
                        },
                    ],
                },
                {
                    year: '2021',
                    color: yellow,
                    linkColor: 'purple',
                    details: [
                        {
                            title: 'VERS L’INFINI ET PLUS LOIN ENCORE!',
                            text: 'L’année 2021 est marquée par une croissance fulgurante de nos activités, probablement saupoudrée d’un peu de candeur et d’insouciance. On appuie sur la pédale d’accélération d’URBANIA France, avec l’embauche de vidéojournalistes, la production de plus en plus de contenus (dont une enquête sur le Youtubeur Norman qui a brisé l’internet!), la vente de plusieurs projets en développement et en production à des diffuseurs comme ARTE et France Télévisions.',
                            image: image2021,
                            verticalImage: true,
                        },
                        {
                            text: 'Du côté ouest de l’Atlantique, on vend notre première fiction - L’Air d’aller - à Télé-Québec, on produit notre premier documentaire d’envergure pour une plateforme anglophone (Kings of Coke sur Crave), on réalise même la première compétition de rap francophone au Québec, La Fin des faibles! L’équipe franchit le cap des 80 employé.e.s, ce qui nous amène à créer de nouveaux départements en communication, talents et culture. Ça demande plus de structure, mais on essaie de garder l’esprit permaculture.',
                        },
                        {
                            title: 'ALLEZ ! DEHORS !',
                            text: 'Près d’un an de télétravail et de confinement, ça nous a tous donné envie de passer le plus de temps possible à l’extérieur. Et c’est pour célébrer le grand air qu’on a lancé en avril 2021 notre nouveau média Dehors, qui invite le plus grand nombre à profiter du... dehors.',
                        },
                    ],
                },
                {
                    year: '2022',
                    color: green,
                    linkColor: 'purple',
                    details: [
                        {
                            title: 'Champagne ! (à boire en live)',
                            text: `Après 2 ans à installer le média et l’agence de contenu d’URBANIA en France, c’est le moment de passer à la vitesse supérieure. Ce sont Florent Peiffer et Elise Richard qui s’affairaient à cette tâche de la main gauche, alors que leur main droite s’occupait de leur entreprise de production de contenu audiovisuel en direct, YouBLive<span style="color: ${purple}"><em>*</em></span>. Comme deux hémisphères de cerveaux sont plus forts qu’un, et qu’on s’est <em>datés</em> suffisamment longtemps pour savoir qu’on ne s’engueule pas pour des niaiseries/conneries, nous avons pris la décision de fusionner toutes ces belles activités complémentaires. YouBLive apporte son expertise en création et production de contenus Live de plus ou moins grande envergure ainsi que sa crédibilité avec les partenaires locaux, URBANIA apporte sa marque et ses capacités éditoriales pour bâtir des audiences. On sabre le champagne : URBANIA France et YouBLive joignent leurs forces et ne forment désormais plus qu’une seule belle équipe d’une vingtaine de personnes qui ne comprennent pas la majorité des référents culturels partagés dans les canaux publics de Slack.`,
                        },
                        {
                            title: `<span style="color: ${purple}">*</span>YouB quoi ? YouBLive ?`,
                            image: null,
                            text: "<p>Fondée en 2017 par Florent (jusqu’alors présentateur en chaîne d’info, désirant fuire à tout prix son ancien patron <a href='https://fr.wikipedia.org/wiki/Vincent_Bollor%C3%A9' target='_blank'>Bolloré</a>, olé!), la société capitalise sur le savoir-faire du direct de son fondateur, l'expertise réseaux sociaux d’Elise (directrice de prod’) et un savant mélange entre le diffusion et le gaming pour la partie technique. S’ils n’ont jamais vraiment formulé directement qu’il s’agissait de rendre l’ordinaire extraordinaire, Florent et Elise ont développé pendant 5 ans l’art de rendre la vie et les silences en temps réel captivants, jusqu’à produire de la fiction ou du documentaire en live.</p><br/><p>«&nbsp;Pardon ? ! ?&nbsp;» vous vous direz, un sourcil levé. Pour vrai. Le 24 avril 2022, le soir du 2e tour des Présidentielles françaises, l’équipe de YBL a réussi l’inédit : diffuser un film de fiction tourné en direct (même la musique était jouée en temps réel!) sur les plateformes d’ARTE. Une histoire se concluant finement avec le dévoilement des résultats du vote. C’était tellement impressionnant et bien ficelé que les spectateurs n’ont d’abord pas cru que c’était en direct. On prépare d’ailleurs le prochain exploit en live…</p>",
                        },
                    ],
                },
            ],
        },
        {
            id: 'employee-title-how-it-works',
            type: 'EmployeeTitle',
            body: 'Comment ça marche',
            colors: { type: 'gradient', colors: [orange, yellow] },
        },
        {
            id: 'employee-text-14',
            type: 'employeeText',
            body: '<p>La force d’URBANIA, l’entreprise, réside dans son modèle d’affaires éclaté, cohérent et organique à la fois. Plusieurs sources de revenus = plus de solidité dans un écosystème en pleine remise en question. Comme un tabouret à 8 pattes : si une patte brise (un changement d’algorithme de Facebook est si vite arrivé), on reste quand même solidement ancré dans le sol.</p>',
        },
        {
            id: 'employee-text-15',
            type: 'employeeText',
            body: '<p>En gros, on a quatre domaines d’expertise qui s’abreuvent au cœur d’URBANIA, composé de l’équipe de création de contenu (que ce soit graphique, vidéo, live, rédactionnel ou interactif). Ces quatre expertises sont la production originale, l’agence de contenu, le laboratoire technologique et nos plateformes média. Ça n’empêche pas l’ensemble des départements de constamment collaborer, de partager leurs expertises, de travailler sur des projets communs, de nourrir les autres. <strong>Nous sommes une hydre à plusieurs têtes, chacune nécessaire au bon fonctionnement de l’écosystème.</strong></p>',
        },
        {
            id: 'employee-subtitle-model',
            type: 'EmployeeSubTitle',
            body: 'La structure d’entreprise',
        },
        {
            id: 'employee-text-16',
            type: 'employeeText',
            body: '<p>Comme on se targue d’embaucher seulement des gens intelligents, on prend pour acquis que vous vous intéressez à ce qui se cache sous le capot de l’entreprise. Ce qui alimente la «&nbsp;machine&nbsp;», les pièces qui la composent. Mais aussi : comment on fait pour générer des revenus qui nous permettent évidemment d’exister et… de payer vos salaires.</p>',
        },
        {
            id: 'employee-business-structure',
            type: 'EmployeeBusinessStructure',
            items: [
                {
                    title: 'Le modèle',
                    image: businessSpiral,
                    entries: [
                        {
                            title: 'Matière première',
                            text: 'Une équipe de créateurs de contenus en quête des meilleures histoires factuelles ou fictives (vidéastes, journalistes, auteurs, designers, photographes, etc).',
                            color: green,
                        },
                        {
                            title: 'Transformation',
                            text: 'Des moyens et outils technologiques pour mettre en forme les contenues de la manière la plus pertinente et cohérente en fonction du mode de distribution et de l’audience ciblée.',
                            color: yellow,
                        },
                        {
                            title: 'Diffusion',
                            text: 'Distribution et monétisation des contenus sur les canaux les plus appropriés pour toucher les cibles convoitées.',
                            color: blue,
                        },
                    ],
                },
                {
                    title: 'Monétisation',
                    image: businessIngots,
                    entries: [
                        {
                            title: 'Production de contenu',
                            listItems: [
                                'Honoraires de conception, stratégie et production de marque.',
                                'Licences de production audiovisuelle pour diffuseurs (télé, plateformes web, podcasts).',
                                'Honoraire de production et de conseils en contenu live',
                            ],
                            color: red,
                        },
                        {
                            title: 'expertise',
                            listItems: [
                                'Licences de produits technologiques pour les éditeurs de contenu.',
                                'Services de conception numérique.',
                                'Services de captation et diffusion en direct sur réseaux sociaux et/ou player privé propriétaire.',
                            ],
                            color: pink,
                        },
                        {
                            title: 'Distribution aux audiences',
                            listItems: [
                                'Création de marques médias et génération d’audiences.',
                                'Diffusion de contenu de marque.',
                                'Commandites de contenu de placement publicitaire.',
                            ],
                            color: orange,
                        },
                    ],
                },
            ],
        },
        {
            id: 'employee-text-17',
            type: 'employeeText',
            body: '<p>...dans tout ce qu’on conçoit, produit et fabrique, les droits restent la propriété d’URBANIA.</p>',
        },
        {
            id: 'employee-subtitle-tentacle',
            type: 'EmployeeSubTitle',
            body: 'Un média tentaculaire',
        },
        {
            id: 'employee-text-18',
            type: 'employeeText',
            body: '<p>Idem pour l’écosystème de nos marques et plateformes de diffusion : chaque élément, est lié aux autres, tout en ayant sa propre mission et son unicité au sein de l’univers URBANIA :</p>',
        },
        {
            id: 'employee-brand-pills',
            type: 'EmployeeBrandPills',
            pills: [
                {
                    id: 'urbania',
                    image: bgurbania,
                    text: 'Généraliste société, humain, humour',
                    color: '#ffdd00',
                    url: 'https://urbania.ca/',
                },
                {
                    id: 'france',
                    image: bgfrance,
                    text: 'Généraliste société, humain, humour',
                    color: '#1d3bf4',
                    url: 'https://urbania.fr/',
                },
                {
                    id: 'universitesText',
                    image: bgperiode,
                    text: 'Vie de campus et enjeux universitaires',
                    color: '#ff662b',
                    url: 'https://urbania.ca/periode-libre',
                },
                {
                    id: 'quatre95',
                    image: bgquatre95,
                    text: 'Finances personelles et monde du travail',
                    color: '#5e79ff',
                    url: 'https://urbania.ca/quatre95',
                },
                {
                    id: 'dehors',
                    image: bgdehors,
                    text: 'Plein air, nature, tourisme et découverte',
                    color: '#566c30',
                    url: 'https://urbania.ca/dehors',
                },
                {
                    id: 'mollo',
                    image: bgmollo,
                    text: 'Parents décontractés',
                    color: '#9916ff',
                    url: 'https://urbania.ca/mollo',
                },
            ],
        },
        {
            id: 'employee-subtitle-lots-of-companies',
            type: 'EmployeeSubTitle',
            body: 'Beaucoup de compagnies<br/>et de sociétés',
        },
        {
            id: 'employee-text-19',
            type: 'employeeText',
            body: '<p>Pour des raisons fiscales 😴 et opérationnelles 😵‍💫, nos différentes activités sont divisées en plusieurs entreprises/sociétés, toutes ayant le même actionnariat. Ça ne change rien à la vie de la grande majorité d’entre vous, mais pour ceux et celles qui auraient une passion pour le Registraire des entreprises du Québec ou la plateforme societe.com, voici grossièrement à quoi ressemble la galaxie de nos compagnies : </p>',
        },
        {
            id: 'employee-galaxy',
            type: 'employeeGalaxy',
            items: [
                {
                    id: 'media',
                    titles: ['URBANIA Média'],
                    text: 'Notre société mère, notre roi soleil, Râ.',
                    color: '#fffc00',
                },
                {
                    id: 'studios',
                    titles: ['URBANIA Studios'],
                    text: 'L’agence de contenu.',
                    color: '#d787ff',
                },
                {
                    id: 'youblive',
                    titles: ['YouBLive'],
                    text: 'Que ce soit pour des chaînes télé ou pour des clients commerciaux, toute notre expertise en production de contenu vidéo en direct passe par le label YouBLive.',
                    color: '#008097',
                    image: youBLive,
                },
                {
                    id: 'tvprod',
                    titles: ['URBANIA TV', 'URBANIA PROD'],
                    text: 'Nos organes de production originaux pour les chaînes.',
                    color: '#ff5566',
                },
                {
                    id: 'magazine',
                    titles: ['URBANIA France', 'Magazine URBANIA'],
                    text: 'Notre porte-voix, nos médias, notre TV5 Monde mais cool.',
                    color: '#0521ce',
                },
                {
                    id: 'folklore',
                    titles: ['Folklore'],
                    text: ' Le label de nos expériences interactives et sites web un peu «&nbsp;fou fou&nbsp;».',
                    color: '#ff0032',
                },
            ],
        },
        {
            id: 'employee-title-our-stories',
            type: 'EmployeeTitle',
            body: 'Nos histoires',
            colors: { type: 'gradient', colors: [pink, red] },
        },
        {
            id: 'employee-text-20',
            type: 'employeeText',
            body: '<p>La mission qu’on s’est donnée, c’est d’être d’audacieux.euses anthropologues (le veston en tweed brun en moins) de la culture populaire et de la société, tous âges et toutes classes sociales confondues.</p>',
        },
        {
            id: 'employee-text-21',
            type: 'employeeText',
            body: '<p>On prend partie pour la diversité des voix et des points de vue, tant chez ceux et celles dont on raconte les histoires que chez nos collaborateur.trice.s, qu’on encourage à expérimenter et à essayer des nouvelles «&nbsp;affaires&nbsp;». On crée des rencontres entre les opposés, on veut générer de l’empathie et de l’ouverture d’esprit.</p>',
        },
        {
            id: 'employee-image-text-ordinary-people',
            type: 'EmployeeImageText',
            body: '<p>Dans nos pages, les vedettes&nbsp;:star:&nbsp;sont traitées comme des gens ordinaires et les gens ordinaires, comme des vedettes&nbsp;:cheese:&nbsp;.</p>',
            color: pink,
            withLine: true,
        },
        {
            id: 'employee-text-22',
            type: 'employeeText',
            body: '<p>URBANIA, c’est aussi une tribune, un porte-voix, pour des témoignages troublants, des points de vue singuliers, des idées à tester, des coups de gueule qui frappent, provoquent des réactions, renversent les perceptions.</p>',
        },
        {
            id: 'employee-subtitle-brand-values',
            type: 'EmployeeSubTitle',
            body: 'Les valeurs de la marque',
        },
        {
            id: 'employee-brand-values',
            type: 'EmployeeValuesPills',
            pills: [
                {
                    id: 'audace',
                    image: valeursAudace,
                    video: valeursAudaceVideo,
                    title: 'L’audace',
                    color: green,
                },
                {
                    id: 'curiosite',
                    image: valeursCuriosite,
                    video: valeursCuriositeVideo,
                    title: 'La curiosité',
                    color: red,
                },
                {
                    id: 'ouverture',
                    image: valeursOuverture,
                    video: valeursOuvertureVideo,
                    title: 'L’ouverture d’esprit',
                    color: blue,
                },
                {
                    id: 'humour',
                    image: valeursHumour,
                    video: valeursHumourVideo,
                    title: 'L’humour',
                    color: purple,
                },
                {
                    id: 'irreverence',
                    image: valeursIrreverence,
                    video: valeursIrreverenceVideo,
                    title: 'L’irrévérence',
                    color: orange,
                },
            ],
        },
        {
            id: 'employee-arrow-text',
            type: 'EmployeeArrowText',
            title: 'Le ton',
            items: [
                {
                    text: 'Ce qui fait qu’URBANIA est URBANIA, ce sont évidemment les visuels décapants; les sujets incongrus décortiqués de manière originale et étonnante; les histoires, personnages et lieux surprenants; et l’irrévérence avec laquelle on les aborde.',
                    image: arrowsMushrooms,
                    color: green,
                },
                {
                    text: 'Mais URBANIA, c’est avant tout un ton. C’est une écriture/une réalisation à vif. Crue. Brute. Parfois rugueuse. Vraie. Authentique.',
                    color: blue,
                },
                {
                    text: 'On cherche l’angle le plus original, le plan le plus imagé, le mot le plus punché, pour arriver à conter l’histoire comme on la raconterait à un ami, au plus près de l’histoire vraie, comme on l’a vécue.',
                    color: purple,
                },
                {
                    text: 'On veut sentir l’odeur de sueur et de vieille bière qui flotte dans le bar crade où se déroule l’entrevue;',
                    color: orange,
                },
                {
                    text: 'On veut entendre le ventre du reporter gargouiller de nervosité avant d’infiltrer un univers méconnu;',
                    image: arrowsClement,
                    color: red,
                },
                {
                    text: 'On veut voir les poils qui sortent des oreilles du vieux bonhomme avec qui on engage la conversation;',
                    image: arrowsOldMan,
                    color: pink,
                },
                {
                    text: 'On veut toucher la banquette en suède usé où la danseuse fait asseoir les clients de ses danses à 10 / connaître la couleur exacte des néons d’une vitrine de peep show;',
                    color: yellow,
                },
                {
                    text: 'On veut goûter au café instantané de la p’tite madame qui nous reçoit dans son salon à la fin pointe des années 80.',
                    image: arrowsOldLady,
                    color: green,
                },
                {
                    text: 'On veut faire ressentir, presque physiquement, l’histoire qu’on raconte.',
                    color: blue,
                },
            ],
        },
        {
            id: 'employee-subtitle-telling-stories',
            type: 'EmployeeSubTitle',
            body: 'Vivre et raconter des histoires',
        },
        {
            id: 'employee-text-23',
            type: 'employeeText',
            body: '<p>Chez URBANIA, on ne «&nbsp;couvre&nbsp;» pas un sujet, on ne va pas à la recherche de clips, on ne rapporte pas de la nouvelle. On prend une bonne respiration et on plonge dans un nouvel univers pour en faire l’expérience, dévoiler les coulisses ou y jeter une nouvelle lumière. On n’est jamais au-dessus de notre sujet : on se met les mains dedans. En fait, on est dedans jusqu’au cou. Pas au-dessus, pas à côté, pas en retrait. Dedans. On est «&nbsp;avec&nbsp;», plutôt que de poser un «&nbsp;regard sur&nbsp;». Avec une subjectivité assumée.</p>',
        },
        {
            id: 'employee-image-text-confort',
            type: 'EmployeeImageText',
            body: '<p>On sort de notre zone de confort. On troque les pantoufles&nbsp;:slippers:&nbsp;pour des pneus&nbsp;:tire:&nbsp;tout terrain. On accroche notre quant-à-soi dans le placard et on laisse tomber le rôle d’observateur&nbsp;:binoculars:&nbsp;.</p>',
            color: yellow,
            withLine: true,
        },
        {
            id: 'employee-text-24',
            type: 'employeeText',
            body: '<p>Parce que ce qu’on fait principalement, c’est vivre des histoires, des aventures, des expériences singulières, et un grand éventail d’émotions non filtrées. Puis, on vous les fait vivre en vous les racontant, de l’intérieur. On vous emmène dans des endroits où vous n’iriez pas, rencontrer des personnages que vous ne présenteriez pas à votre mère.</p>',
        },
        {
            id: 'employee-subtitle-role',
            type: 'EmployeeSubTitle',
            body: 'Le rôle d’URBANIA',
        },
        {
            id: 'employee-text-25',
            type: 'employeeText',
            body: '<p>Notre communauté, c’est le vrai «&nbsp;vrai monde&nbsp;». On donne la parole à des gens qui n’ont pas de voix ailleurs : des personnages qu’on a rarement entendus, des gens qu’on snobe, qu’on regarde de haut ou qu’on ne remarque pas. Des gens avec qui on n’a rien en commun a priori. Mais avec qui on développe un lien, un attachement, parce qu’on les découvre, une histoire à la fois.</p>',
        },
        {
            id: 'employee-text-26',
            type: 'EmployeeImageText',
            body: '<p>Il est là, notre humanisme.</p>',
            color: blue,
            withLine: true,
        },
        {
            id: 'employee-text-27',
            type: 'employeeText',
            body: '<p>Nous, on débusque l’incongru, on magnifie l’ordinaire et on trouve la beauté là où les autres ne voient que la banalité ou de la laideur. Sans jugement. Mais avec un sourire en coin.</p>',
        },
        {
            id: 'employee-cta',
            type: 'EmployeeCallToAction',
            body: '<p>Poursuivre la lecture:</p>',
            buttons: [
                {
                    text: 'Guide Québec',
                    url: 'https://www.notion.so/urbania/Accueil-Le-grand-guide-de-l-URBANIEN-NE-02d86983d7a944bfb6f7eeda6621e7e8?pvs=4',
                    colors: { type: 'gradient', colors: [pink, red] },
                },
                {
                    text: 'Guide France',
                    url: 'https://www.notion.so/urbania/Accueil-Le-grand-guide-de-l-URBANIEN-NE-6ce4868ded5a4b3e9be26fbe81049cbe?pvs=4',
                    colors: { type: 'gradient', colors: [pink, red] },
                },
            ],
        },
    ],
};
